<template>
  <div class="introduce animation">
    <el-container>
      <el-main style="margin:0px;padding:0px;">
          <el-row style="margin-top:0px,padding-top:0px;">
            <span style="font-size: 22px;">公司简介</span>
          </el-row>
          <el-row>
            <el-col :span="8">
              <img width="330px" height="210px" src="@/assets/image/chengxi_place.png">
            </el-col>
            <el-col :span="16">
              <p style="margin-top:0px;padding-top:0px">
              合肥成蹊科技服务有限责任公司（简称：成蹊科技），公司成立于2019年8月17日，位于中国科技之城，安徽省府城市、
              文化科教中心--合肥市蜀山区。<br/><br/>
              公司拥有专业的技术服务团队并致力于民生科技产品研发、服务国家及地方政府环境监测、改善社区生活环境及生活品质。提升百姓对食品质量安全诉求和美好愿望。<br/><br/>
              </p>
              <p>业务联系：张先生</p><p>联系电话：13485715181</p>
            </el-col>
          </el-row>
          <el-row>
            <span style="font-size: 20px;">公司愿景</span>
          </el-row>
          <el-row>
            <p style="margin-top:0px;padding-top:0px">为青山绿水、品质安全的美好生活而奋斗！</p>
          </el-row>
          <el-row>
            <span style="font-size: 20px;">主营业务</span>
          </el-row>
          <el-row>
            <el-col :span="6">
              <img width="100px" height="100px" src="@/assets/image/iot.png"  @click="dialog1=true" >
            </el-col>
            <el-col :span="6">
              <img width="100px" height="100px" src="@/assets/image/trace.png"  @click="dialog2=true">
            </el-col>
            <el-col :span="6">
              <img width="100px" height="100px" src="@/assets/image/service.png"  @click="dialog3=true">
            </el-col>
            <el-col :span="6">
              <img width="100px" height="100px" src="@/assets/image/advice.png"  @click="dialog4=true">
            </el-col>
          </el-row>
      </el-main>
    </el-container>
    <el-dialog
      title="业务范围"
      :visible.sync="dialog1"
      width="15%"
      :before-close="handleClose"
      :close-on-click-modal="false">
      <p>生态环境监测</p>
      <p>河湖水质监测</p>
      <p>生态农业监测</p>
      <p>生产物联监测</p>
    </el-dialog>
    <el-dialog
      title="业务范围"
      :visible.sync="dialog2"
      width="15%"
      :before-close="handleClose"
      :close-on-click-modal="false">
      <p>农资防伪溯源</p>
      <p>食品防伪溯源</p>
      <p>饮品防伪溯源</p>
      <p>原料防伪溯源</p>
      <p>其他防伪溯源</p>
    </el-dialog>
    <el-dialog
      title="业务范围"
      :visible.sync="dialog3"
      width="15%"
      :before-close="handleClose"
      :close-on-click-modal="false">
      <p>闲置资源服务</p>
      <p>家政家教服务</p>
      <p>社区配送服务</p>
      <p>社区互助服务</p>
    </el-dialog>
    <el-dialog
      title="业务范围"
      :visible.sync="dialog4"
      width="15%"
      :before-close="handleClose"
      :close-on-click-modal="false">
      <p>防伪溯源咨询</p>
      <p>环保监测咨询</p>
      <p>生态农业咨询</p>
      <p>数据采集咨询</p>
      <p>信息化建设咨询</p>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'introducePage',
  data () {
    return {
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false
    }
  }
}
</script>

<style lang="less" scoped>
body {
  margin: 0px;
}
.introduce {
  animation-name: 'ripple';
  animation-duration: 10s;
  animation-delay: 1s;
}
@keyframes ripple {
  30% {
    opacity:0.35;
    width:30%;
    height:30%;
  }
  100% {
    opacity:0.9;
    width:100%;
    height:100%;
  }
}
.el-main {
  margin: 10px;
  padding: 10px;
  height: 550px;
}
.el-row {
  margin-top: 0px;
  padding-top: 10px;
  text-align: left;
}
</style>
